import * as React from 'react';

interface IPagerProps {
  items: number;
  activePage: number;
  onSelect: (pageNumer: number) => void;
}

export default class Pager extends React.Component<IPagerProps, {}> {

  // Max. Anzahl an Seiten die auf die Standardbreite passen
  maxItems: number = 14;

  private renderPageButtons() {
    const { activePage, items, onSelect } = this.props;
    let showEllipsis: boolean = items > this.maxItems;
    let buttons = [];
    for (let i = 0; i < items; i++) {
      const className = (i + 1) === activePage ? 'active' : '';
      // Wenn es mehr Seiten gibt als in die Breite passen, wird mittig ein Button mit '...' angezeit, so wie in neuen Bootstrap Versionen
      if (showEllipsis && i === this.maxItems - 1) {
        const buttonCaption = ((activePage < this.maxItems) || (activePage === items)) ? '...' : activePage;
        buttons.push(<li key="pager-btn-ellipsis" className="disabled"><a role="button" href="#">{buttonCaption}</a></li>);
        buttons.push(<li key="pager-btn-ellipsis-end" className={activePage === items ? 'active' : ''} onClick={() => onSelect(items)}><a role="button" href="#">{items}</a></li>);
        break;
      }
      buttons.push(<li key={`pager-btn-${i}`} className={className} onClick={() => onSelect(i + 1)}><a role="button" href="#">{i + 1}</a></li>);
    }
    return buttons;
  }

  renderNavButtonsLeft() {
    // Buttons nur aktivieren wenn nicht am Anfang der Liste
    let enabled = this.props.activePage > 1;
    let buttons = [];
    if (enabled) {
      buttons.push(<li key="pager-btn-first" className=""><a role="button" href="#" onClick={() => this.props.onSelect(1)}><span aria-label="First">«</span></a></li>);
      buttons.push(<li key="pager-btn-prev" className=""><a role="button" href="#" onClick={() => this.props.onSelect(this.props.activePage - 1)}><span aria-label="Previous">‹</span></a></li>);
    } else {
      buttons.push(<li key="pager-btn-first" className="disabled"><a role="button" href="#"><span aria-label="First">«</span></a></li>);
      buttons.push(<li key="pager-btn-prev" className="disabled"><a role="button" href="#"><span aria-label="Previous">‹</span></a></li>);
    }
    return buttons;
  }

  renderNavButtonsRight() {
    // Buttons nur aktivieren wenn nicht am Ende der Liste
    let enabled = this.props.activePage < this.props.items;
    let buttons = [];
    if (enabled) {
      buttons.push(<li key="pager-btn-next" className=""><a role="button" href="#" onClick={() => this.props.onSelect(this.props.activePage + 1)}><span aria-label="Next">›</span></a></li>);
      buttons.push(<li key="pager-btn-last" className=""><a role="button" href="#" onClick={() => this.props.onSelect(this.props.items)}><span aria-label="Last">»</span></a></li>);
    } else {
      buttons.push(<li key="pager-btn-next" className="disabled"><a role="button" href="#"><span aria-label="Next">›</span></a></li>);
      buttons.push(<li key="pager-btn-last" className="disabled"><a role="button" href="#"><span aria-label="Last">»</span></a></li>);
    }
    return buttons;
  }

  render() {
    return (
      <div>
        <ul className="pagination" style={{marginBottom: '15px', float: 'right'}}>
          {this.renderNavButtonsLeft()}
          {this.renderPageButtons()}
          {this.renderNavButtonsRight()}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/Pager.tsx